export default __webpack_public_path__ + "static/media/annualLecture18.1367a262.png";